import React, { useState, useEffect, useRef } from 'react';
import '../pages/css/Work.css';

const Experience = () => {
    const [activeFilter, setActiveFilter] = useState('All');
    const timelineRef = useRef(null);

    const experiences = [
        {
            title: "SDE Intern",
            company: "Monkspaces.ai",
            type: "Full-time",
            duration: "April 2025 - Present",
            location: "Bangalore, Karnataka, India",
            description: "Remote",
            skills: ["MERN", "SLACK API", "Microservices", "REST APIs"],
            category: "Development"
        },
        {
            title: "Full-Stack Intern",
            company: "Geta.ai",
            type: "Full-time",
            duration: "Jan 2025 - March 2025",
            location: "Pune, Maharashtra, India",
            description: "On-site",
            skills: ["MERN", "Python", "AWS", "Microservices", "REST APIs"],
            category: "Development"
        },
        {
            title: "GDG Lead",
            company: "GDG SGU",
            type: "Full-time",
            duration: "Sep 2024 - Present",
            location: "Kolhapur, Maharashtra, India",
            description: "On-site",
            skills: ["Team Management", "Event Management", "Community Building", "Public Speaking"],
            category: "Leadership"
        },
        {
            title: "Full Stack Developer",
            company: "SGU's Consultancy Services",
            type: "Internship",
            duration: "Mar 2024 - Aug 2024",
            location: "Kolhar, Karnataka, India",
            description: "Worked on project management, software projects, and React.js development.",
            skills: ["Project Management", "Software Projects", "React.js"],
            category: "Development"
        },
        {
            title: "Software Developer Intern",
            company: "Bluecrest Software",
            type: "Internship",
            duration: "Nov 2023 - Mar 2024",
            location: "Remote",
            description: "Built UI components, integrated REST APIs, and created chatbot interfaces with a focus on smooth user interactions.",
            skills: ["React.js", "Material-UI", "Bootstrap", "GitHub", "Soft UI", "REST APIs"],
            category: "Development"
        },
        {
            title: "Professional Freelancer",
            company: "Freelance",
            type: "Freelance",
            duration: "Mar 2023 - Feb 2024",
            location: "Remote",
            description: "Collaborated with international clients to build web applications. Also served as an API Developer Instructor at SGU and AmtechNow.",
            skills: ["Project Management", "Software Development", "Consulting", "API Instructor"],
            category: "Freelance"
        },
        {
            title: "Web Development Intern",
            company: "Pusht Health Service",
            type: "Internship",
            duration: "Jul 2023 - Aug 2023",
            location: "Remote",
            description: "Designed high-converting landing pages, boosting LinkedIn engagement by 40% and improving lead conversions.",
            skills: ["Web Design"],
            category: "Design"
        },
        {
            title: "Full Stack Developer Intern",
            company: "Edureka",
            type: "Internship",
            duration: "Mar 2022 - Nov 2022",
            location: "Remote",
            description: "Gained hands-on experience with full-stack web development through real-world projects. Mentored and guided in various technologies.",
            skills: ["HTML", "Node.js", "JavaScript", "Git", "React.js", "CSS", "Bootstrap", "REST APIs", "MongoDB"],
            category: "Development"
        },
    ];

    const categories = ['All', 'Development', 'Design', 'Leadership', 'Freelance'];

    const filteredExperiences = activeFilter === 'All'
        ? experiences
        : experiences.filter(exp => exp.category === activeFilter);

    // Set item index for staggered animations
    useEffect(() => {
        if (timelineRef.current) {
            const timelineItems = timelineRef.current.querySelectorAll('.timeline-item');
            timelineItems.forEach((item, index) => {
                item.style.setProperty('--item-index', index + 1);
            });
        }
    }, [filteredExperiences]);

    // Reset animations when filter changes
    useEffect(() => {
        if (timelineRef.current) {
            const timelineItems = timelineRef.current.querySelectorAll('.timeline-item');

            // Reset animations properly without ESLint warning
            timelineItems.forEach((item) => {
                item.style.animation = 'none';
                // Fix for ESLint warning - use void with the expression
                void item.offsetHeight; // Safely trigger reflow
                item.style.animation = null;
            });
        }
    }, [activeFilter]);

    return (
        <div id="experience" className="experience-section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Work Experience</h2>
                    <div className="section-underline"></div>
                </div>

                <div className="filter-buttons">
                    {categories.map((category, idx) => (
                        <button
                            key={idx}
                            className={`filter-btn ${activeFilter === category ? 'active' : ''}`}
                            onClick={() => setActiveFilter(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                <div className="timeline" ref={timelineRef}>
                    {filteredExperiences.map((exp, index) => (
                        <div className="timeline-item" key={index}>
                            <div className="timeline-marker"></div>
                            <div className="timeline-content">
                                <div className="experience-card">
                                    <div className="exp-header">
                                        <h3 className="exp-title">{exp.title}</h3>
                                        <span className="exp-company">{exp.company}</span>
                                    </div>

                                    <div className="exp-meta">
                                        <span className="exp-duration">
                                            <i className="bi bi-calendar3"></i> {exp.duration}
                                        </span>
                                        <span className="exp-type">
                                            <i className="bi bi-briefcase"></i> {exp.type}
                                        </span>
                                        <span className="exp-location">
                                            <i className="bi bi-geo-alt"></i> {exp.location}
                                        </span>
                                    </div>

                                    <p className="exp-description">{exp.description}</p>

                                    <div className="skills-container">
                                        {exp.skills.map((skill, skillIndex) => (
                                            <span className="skill-tag" key={skillIndex}>{skill}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Experience;